// extracted by mini-css-extract-plugin
export var buy_now_btn = "index-module--buy_now_btn--f39df";
export var close_btn = "index-module--close_btn--0a591";
export var content_btn_wrapper = "index-module--content_btn_wrapper--8d8e6";
export var content_deco = "index-module--content_deco--c505d";
export var content_en = "index-module--content_en--5a68c";
export var content_ja = "index-module--content_ja--b0a76";
export var content_wrapper = "index-module--content_wrapper--b24c9";
export var count_down_content_wrapper = "index-module--count_down_content_wrapper--9a825";
export var count_down_part = "index-module--count_down_part--98d6f";
export var deco_line = "index-module--deco_line--f79c8";
export var en = "index-module--en--d1e4b";
export var icon = "index-module--icon--e11f0";
export var inner = "index-module--inner--d7434";
export var is_end = "index-module--is_end--49dcd";
export var ja = "index-module--ja--02b04";
export var number_wrapper = "index-module--number_wrapper--c657b";
export var outer = "index-module--outer--bcb48";
export var snow_canvas = "index-module--snow_canvas--8ff6c";
export var time_number_text = "index-module--time_number_text--cf7b3";
export var time_suffix = "index-module--time_suffix--8ff14";
export var wrapper = "index-module--wrapper--54e8b";